/**
 * Validates if a filename contains invalid characters that could cause issues
 * with URL encoding or file system paths.
 *
 * @param filename - The filename to validate
 * @returns true if filename is valid, false if it contains invalid characters
 */
export const isValidFilename = (filename: string): boolean => {
  const invalidChars = /[/\\?&%]/;
  return !invalidChars.test(filename);
};
